import React, { useState, useEffect } from "react";
import ChoiseCard from "../../ui/ChoiseCard/ChoiseCard";
import styles from "./Step1_jurisdiction.module.scss";
import ukraineImage from "../../../assets/icons/Ukraine.svg";
import planetImage from "../../../assets/icons/planet.svg";
import brandrLogo from "../../../assets/logo/Brandr_Logo.svg";

import { STEPS, JURISDICTION_CHOICES } from "../../../constants";

const Step1Jurisdiction = ({ onNextStep }) => {
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (selected) {
      const timer = setTimeout(() => {
        onNextStep({ stepId: STEPS.JURISDICTION, choice: selected });
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [selected, onNextStep]);

  const handleSelect = (choice) => {
    if (!selected) { // Prevent clicking again while timer is active
      setSelected(choice);
    }
  };

  return (
    <div className={styles.step1}>
      <img src={brandrLogo} alt="BrandR Logo" />
      <div className={styles.content}>
        <h2>Де плануєте реєструвати торгову марку?</h2>
        <div className={styles.gridCards}>
          <ChoiseCard isSelected={selected === JURISDICTION_CHOICES.UA} onClick={() => handleSelect(JURISDICTION_CHOICES.UA)}>
            <img src={ukraineImage} alt="Ukraine Map" />
            <h3>В Україні</h3>
            <p>Автоматичний розрахунок вартості та онлайн-подача заявки.</p>
          </ChoiseCard>
          <ChoiseCard isSelected={selected === JURISDICTION_CHOICES.EU} onClick={() => handleSelect(JURISDICTION_CHOICES.EU)}>
            <img src={planetImage} alt="Planet Svg" />
            <h3>За кордоном</h3>
            <p>
              Реєстрація в ЄС, США та ін.
              <br></br>
              <span><strong>Потребує консультації експерта.</strong></span>
            </p>
          </ChoiseCard>
        </div>
      </div>
    </div>
  );
};

export default Step1Jurisdiction;